import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../../data.service';
import { CommonService } from '../../../services/common.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { GlobalConstant } from '../../../constants/global-constant';
import { NotificationService } from "../../../services/notification.service";


@Component({
  selector: 'app-test-instructions',
  templateUrl: './test-instructions.component.html',
  styleUrls: ['./test-instructions.component.css']
})
export class TestInstructionsComponent implements OnInit {

 formSubmitAttempt: boolean;
 globalError: any;
 
 _compSubMapApiRes: any;
 _compSubMapApiResMap: any;
 
 competitionTypes: any //[];
 subjectTypes: any //[];
 compitionLanguages: any; //[];
 testTypes: any; //[];
 
 userPendingTests: any; //[]
 
 indivCompSubMappingDefaultData = this.getDefaultFormData();
  
  extractedCompanyId = -1;
  
  constructor(public appData: AppData, private dataService: DataService,  private commonService: CommonService, 
  				private router: Router,
  				public notificationService: NotificationService) { }

  ngOnInit(): void {
	  this.compitionLanguages = [];
	  this.compitionLanguages.push({name:'EN', description:'English'});
	  this.compitionLanguages.push({name:'HN', description:'Hindi'});
	  this.testTypes = [];
	  this.testTypes.push({name:'REGULAR', description:'Regular/Daily Test'});
	  this.testTypes.push({name:'SCHEDULED', description:'Scheduled Test'});
	  
	  var sId = this.dataService.getFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID);
	  if(sId!=null && sId!=undefined && sId!=''){
		  this.extractedCompanyId = this.commonService.extractEnterpriseIdFromUniqueId(sId);
	  }
	  
	  this.appData.isAuthenticated.subscribe(message=> {
		if(message === true){
		  this.retrieveIndivCompSubMapping(this.appData.userId);
		  this.retrievePendingTestRecords(this.appData.userId);
			
			if(this.appData.userId === 'Admin'){
			
			} else {
				
			}
		}
	  });
	  
		
		
  }

 
 
  form = new FormGroup({
    competitionTypeStr: new FormControl(''),
    subjectTypeStr: new FormControl(''),
    compitionLanguageStr: new FormControl(''),
    testTypeStr: new FormControl('')
    
  });

 retrieveCompLanguage(){
	 
 }
 

 retrieveCompType(){
	 
 }
 
  retrievePendingTestRecords(indivLoginEmailId){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : indivLoginEmailId};
    //Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesGetIndivTestRecord, body).subscribe((res: any)=>{
      console.log(res);
      this.userPendingTests =  res.data;
      
    });
  }

  retrieveIndivCompSubMapping(indivLoginEmailId){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : indivLoginEmailId};
    //Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesIndivCompSubMappingList, body).subscribe((res: any)=>{
      console.log(res);
      this._compSubMapApiRes = res.data;
      this._compSubMapApiResMap = new Map(Object.entries( res.data.map));
      //this._compSubMapApiResMap = Object.entries( res.data.map);
      this.competitionTypes = res.data.indivList;
      
      this.competitionTypes = [];
      
      this._compSubMapApiResMap.forEach((value, key) => {
		  
		  let name = value[0].compSubMappingList[0].competitionType;
		  let desc = value[0].compSubMappingList[0].competitionTypeDesc;
		  
		  this.competitionTypes.push({'name': name, 'description':desc});
	  });
	  
      if(this.competitionTypes != undefined && this.competitionTypes.length == 1){
		  this.indivCompSubMappingDefaultData.competitionTypeStr = this.competitionTypes[0].name;
		  this.form.patchValue(this.indivCompSubMappingDefaultData);
		  this.competitionTypeChange(this.competitionTypes[0].name);
	  }
      
      this.form.patchValue(this.indivCompSubMappingDefaultData);
      /**
      if(this.indivCompetitionSubjectMapping != undefined && this.indivCompetitionSubjectMapping.length > 0){
        console.log('this.indivCompetitionSubjectMapping.length:' + this.indivCompetitionSubjectMapping.length);
        //let temp = indivCompSubMappingDefaultData; //{ 'indivCompSubList' : [] }
        let len = this.indivCompSubArray.length;
      	for(let ix=0; ix<len; ix++){
      		this.indivCompSubArray.removeAt(0);
      		this.indivCompSubMappingDefaultData.indivCompSubList.splice(0,1);
      	}
      	//this.indivCompSubMappingDefaultData.indivCompSubList =[];
      	for(let i=0; i<this.indivCompetitionSubjectMapping.length; i++){
      		//let temp = this.indivCompetitionSubjectMapping[i].indivCompSubList[0];
      		//temp.id = this.indivCompetitionSubjectMapping[i].id;
      		//temp.noOfQuestionsToAttempt = this.indivCompetitionSubjectMapping[i].noOfQuestionsToAttempt;
      		
      		this.indivCompSubArray.push(this.getCompSubForm(this.indivCompetitionSubjectMapping[i].noOfQuestionsToAttempt) );
      		this.indivCompSubMappingDefaultData.indivCompSubList.push(this.indivCompetitionSubjectMapping[i].compSubMappingList[0]);
      		this.indivCompSubMappingDefaultData.indivCompSubList[i].id = this.indivCompetitionSubjectMapping[i].id;
      	}
      	    
      		this.indivCompSubMapping.patchValue(this.indivCompSubMappingDefaultData); 	 	
      } */
    });
  }
  
  competitionTypeChange(competitionTypeSelectedValue){
	  this.subjectTypes = [];
	  var formData = this.form.value;
	   this.copyData(formData, this.indivCompSubMappingDefaultData);
	   
	  if(competitionTypeSelectedValue !== undefined){
		  this._compSubMapApiResMap.forEach((value, key) => {
		  	if(key === competitionTypeSelectedValue){
				  value.forEach(data =>{
					  let name = data.compSubMappingList[0].subjectType;
			 		  let desc = data.compSubMappingList[0].subjectTypeDesc;
			 		  this.subjectTypes.push({'name': name, 'description':desc});
				  });
				  if(this.subjectTypes.length === 1){
					  this.indivCompSubMappingDefaultData.subjectTypeStr = this.subjectTypes[0].name;
				  } else {
					   this.indivCompSubMappingDefaultData.subjectTypeStr = '';;
				  }
				  this.form.patchValue(this.indivCompSubMappingDefaultData);
			  }
		  });
	  } else {
		  this.indivCompSubMappingDefaultData.competitionTypeStr = '';
		  this.indivCompSubMappingDefaultData.subjectTypeStr = '';
		  this.form.patchValue(this.indivCompSubMappingDefaultData);
	  }
  }
  
  copyData(from, to){
	to.competitionTypeStr = from.competitionTypeStr;
  	to.subjectTypeStr = from.subjectTypeStr;
  	to.compitionLanguageStr = from.compitionLanguageStr;
  	to.testTypeStr = from.testTypeStr;
   }
	
 onSubmit() {
  	this.formSubmitAttempt = true;
  	var body = this.form.value;
  	body.userId = this.appData.userId;
  	
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesStartTest, body).subscribe((res: any)=>{
		if(res.status === 'SUCCESS')
  			this.router.navigate(['/dashboard-test-series', { }]);
  		else {
  			this.notificationService.error("There is some error. Please try after sometime.");
  			this.formSubmitAttempt = false;
		}
  	});
  }

 continuePreviousTest(userPendingTestData) {
  	//this.formSubmitAttempt = true;
  	var body = this.form.value;
  	body.userId = this.appData.userId;
  	body.testRecordId = userPendingTestData.id; //pendingTestRecordId;
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesContinuePreviousTest, body).subscribe((res: any)=>{
		if(res.status === 'SUCCESS')
  			this.router.navigate(['/dashboard-test-series', { }]);
  		else {
  			this.notificationService.error("There is some error. Please try after sometime.");
  			//this.formSubmitAttempt = false;
		}
  	});
  }
  
  clearCompetitionInitData(){
	  
	  
  }
  
  getDefaultFormData(){
	  return {
	  	competitionTypeStr : '',
	  	subjectTypeStr : '',
	  	compitionLanguageStr : 'EN',
	  	testTypeStr : ''
	  }
  }
  
  
}
